"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const react_native_paper_dates_1 = require("react-native-paper-dates");
const App_1 = __importDefault(require("../src/App"));
const app_json_1 = require("../src/app.json");
// Register translation for datepicker
react_native_paper_dates_1.registerTranslation('en', react_native_paper_dates_1.en);
react_native_1.AppRegistry.registerComponent(app_json_1.name, () => App_1.default);
react_native_1.AppRegistry.runApplication(app_json_1.name, { rootTag: document.getElementById('root') });
